function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 2.00058C5.58214 2.00058 2 5.58272 2 10.0006C2 14.4184 5.58214 18.0006 10 18.0006C14.4179 18.0006 18 14.4184 18 10.0006C18 5.58272 14.4179 2.00058 10 2.00058ZM8.57143 12.7149C8.57143 12.7934 8.50714 12.8577 8.42857 12.8577H7.57143C7.49286 12.8577 7.42857 12.7934 7.42857 12.7149V7.28629C7.42857 7.20772 7.49286 7.14344 7.57143 7.14344H8.42857C8.50714 7.14344 8.57143 7.20772 8.57143 7.28629V12.7149ZM12.5714 12.7149C12.5714 12.7934 12.5071 12.8577 12.4286 12.8577H11.5714C11.4929 12.8577 11.4286 12.7934 11.4286 12.7149V7.28629C11.4286 7.20772 11.4929 7.14344 11.5714 7.14344H12.4286C12.5071 7.14344 12.5714 7.20772 12.5714 7.28629V12.7149Z",
  fill: "#99A6B0"
});

const SvgSuspend = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuspend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/suspend.697787a8.svg";
export { ForwardRef as ReactComponent };